import { TreatmentType } from 'app/core/enums';

const treatmentTypePreviewImagesPrefix = `assets/images/patient-file-preview-images/`;

export const TreatmentTypePreviewImages = [
  {
    treatmentTypeId: TreatmentType.ClearAligner,
    name: 'Front Face',
    imagePath: `${treatmentTypePreviewImagesPrefix}clear-aligner-front-face.webp`,
  },
  {
    treatmentTypeId: TreatmentType.ClearAligner,
    name: 'Front Smile',
    imagePath: `${treatmentTypePreviewImagesPrefix}clear-aligner-front-smile.webp`,
  },
  {
    treatmentTypeId: TreatmentType.ClearAligner,
    name: 'Right Side Face',
    imagePath: `${treatmentTypePreviewImagesPrefix}clear-aligner-right-side-face.webp`,
  },
  {
    treatmentTypeId: TreatmentType.ClearAligner,
    name: 'Left Side Face',
    imagePath: `${treatmentTypePreviewImagesPrefix}clear-aligner-left-side-face.webp`,
  },
  {
    treatmentTypeId: TreatmentType.ClearAligner,
    name: 'Upper Jaw',
    imagePath: `${treatmentTypePreviewImagesPrefix}clear-aligner-upper-jaw.webp`,
  },
  {
    treatmentTypeId: TreatmentType.ClearAligner,
    name: 'Lower Jaw',
    imagePath: `${treatmentTypePreviewImagesPrefix}clear-aligner-lower-jaw.webp`,
  },
  {
    treatmentTypeId: TreatmentType.ClearAligner,
    name: 'Front Teeth',
    imagePath: `${treatmentTypePreviewImagesPrefix}clear-aligner-front-teeth.webp`,
  },
  {
    treatmentTypeId: TreatmentType.ClearAligner,
    name: 'Right Side Teeth',
    imagePath: `${treatmentTypePreviewImagesPrefix}clear-aligner-right-side-teeth.webp`,
  },
  {
    treatmentTypeId: TreatmentType.ClearAligner,
    name: 'Left Side Teeth',
    imagePath: `${treatmentTypePreviewImagesPrefix}clear-aligner-left-side-teeth.webp`,
  },
  {
    treatmentTypeId: TreatmentType.ClearAligner,
    name: 'Upload your design here',
    imagePath: `${treatmentTypePreviewImagesPrefix}clear-aligner-front-teeth.webp`,
  },
];
